module.exports = __webpack_public_path__ + "img/290e3be.jpg";